/** @format **/

import { generateScreen } from "./generator";

const verificationScreens = (i18n) => ({
  smsCode: {
    type: "sms-code",
    params: {
      associatedPhoneNumberUrl: "/chapter3/phone-number-validation",
      conditions: [
        {
          property: "partner.enableOTP",
          value: true,
        },
      ],
    },
  },

  idType: {
    type: "question.id-type",
    params: {
      list: true,
      scrollShadow: true,
      text: () => i18n.t("specifics:idType.select"),
      dispatchKey: "updateUser",
      propertyName: "idType",
      currentAnswer: (store) => store.state.user.idType,
      answers: (store) => [
        { id: "national_id", label: i18n.t("specifics:idType.idCard") },
        { id: "passport", label: i18n.t("specifics:idType.passport") },
        {
          id: "driver_license",
          label: i18n.t("specifics:idType.driverLicense"),
        },
      ],
      conditions: [
        {
          property: "app.manualVerificationFlow",
          value: true,
        },
      ],
    },
  },

  securityQuestionAnswer: {
    type: "open-question.security-question-answer",
    params: {
      title: () => i18n.t("specifics:open-question.title"),
      placeholder: (store) => i18n.t("specifics:open-question.placeholder"),
      description: (store) => i18n.t("specifics:open-question.description"),
      currentAnswer: (store) => store.state.user.openQuestionAnswer,
      dispatchKey: "updateUser",
      propertyName: "openQuestionAnswer",
    },
  },

  documentUploader: {
    type: "document-uploader",
    hideTitle: true,
    params: {
      header: () => i18n.t("specifics:documentUploader.header"),
      infoImage: require("static/uploader-info.svg"),
      buttonText: (store) => i18n.t("specifics:documentUploader.upload"),
      dispatchKey: "updateUser",
      propertyName: "uploadedDocumentFrontURL",
      documentFace: "front",
      hasBack: true,
      conditions: [
        {
          property: "app.manualVerificationFlow",
          value: true,
        },
      ],
    },
  },

  documentUploaderBack: {
    type: "document-uploader.back",
    hideTitle: true,
    params: {
      header: () => i18n.t("specifics:documentUploader.header"),
      infoImage: require("static/uploader-info-back.svg"),
      buttonText: (store) => i18n.t("specifics:documentUploader.upload"),
      dispatchKey: "updateUser",
      propertyName: "uploadedDocumentBackURL",
      documentFace: "back",
      conditions: [
        {
          property: "app.manualVerificationFlow",
          value: true,
        },
        {
          property: "user.idType",
          not: true,
          value: "passport",
        },
      ],
    },
  },
});

export const getVerificationScreens = generateScreen.bind(
  null,
  verificationScreens
);



// WEBPACK FOOTER //
// ./src/partners/config/screens/verification.js